import GetInTouch from './GetInTouch';
import QuickLinks from './QuickLinks';
import ServicesMenu from './ServicesMenu';
import Subscribe from './Subscribe';
export default function FooterFive(){
    return(
        <>
            <footer class="footer-area pt-95 home-5">
		<div class="container">
			<div class="row mb-15">
				<div class="col-xl-3 col-lg-6 col-md-6 wow fadeInUp2" data-wow-delay=".1s">
                    <div className="footer__widget mb-30">
                        <GetInTouch/>
                    </div>
				</div>
				<div class="col-xl-3 col-lg-6 col-md-6 wow fadeInUp2" data-wow-delay=".3s">
                    <div className="footer__widget mb-30">
                        <QuickLinks/>
                    </div>
				</div>
				<div class="col-xl-3 col-lg-6 col-md-6 wow fadeInUp2" data-wow-delay=".5s">
                    <div className="footer__widget mb-30">
                        <Subscribe/>
					</div>
				</div>
				<div class="col-xl-3 col-lg-6 col-md-6 wow fadeInUp2" data-wow-delay=".7s">
					<div class="footer__widget mb-30 pl-55 pl-lg-0 pl-md-0 pl-xs-0">
						<ServicesMenu/>
					</div>
				</div>
			</div>
			<div class="copyright-section">
				<div class="row">
					<div class="col-xl-12 col-lg-12 col-md-12 text-center">
						<div class="copyright">
							<h6>Copyright ©{new Date().getFullYear()} Waretech. Designed &amp; Developed
								by Reacthemes</h6>
						</div>
					</div>
				</div>
			</div>
		</div>
	</footer>
        </>
    )
}